<template>
  <div v-if="isError && isText" class="el-form-item__error">
    <slot>
      {{ message }}
    </slot>
  </div>
  <div v-else-if="isError && isIcon">
    <el-tooltip class="error-tooltip" placement="top">
      <div slot="content">
        <slot />
      </div>
      <i class="material-icons m-icon error-icon">warning</i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    validation: {
      type: String,
    },
    mode: {
      type: String,
      default: "text",
    },
  },

  computed: {
    isError() {
      return this.data && this.data.$dirty && this.data.$error && !this.data[this.validation];
    },
    isText() {
      return this.mode === "text";
    },
    isIcon() {
      return this.mode === "icon";
    },
    message() {
      switch (this.validation) {
        case "required":
          return "El campo es obligatorio";
        case "requiredIf":
          return "El campo es obligatorio";
        case "iban":
          return "El IBAN indicado es inválido";
        case "currency":
          return "Introduce un importe válido";
        case "email":
          return "Introduce un correo electrónico válido";
        case "inUse":
          return "Este valor ya está en uso";
        case "license":
          return "La licencia no es válida";
        default:
          return "Dato inválido";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item__error {
  position: static !important;
}

.error-tooltip {
  line-height: 28px;
}

.error-icon {
  color: #d24e2b;
  cursor: help;
  font-size: 18px !important;
}
</style>
